import React from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation, useParams, useSearchParams} from "react-router-dom";
import { FormattedMessage, useIntl  } from 'react-intl';

import { Tabs } from 'antd';

import { PRINTERS_PATH } from '../utils/constants';
import BreadcrumbHeader from './BreadcrumbHeader';
import ReportsFilter from './ReportsFilter';
import DetailedReport from './DetailedReport';
import {getPrinterDetailedColumns} from './GetDetailedColumns';
import PrinterReportGeneral from './PrinterReportGeneral';

const PrinterReport = (props) => {

    let params = useParams();
    const printerId = parseInt(params['id'], 10);

    const location = useLocation();
    const intl = useIntl();

    const [searchParams] = useSearchParams();
    const serverId = searchParams.get("serverId")

    let filterData = useSelector(state => state.reportFilter);
    let printers = useSelector(state => state.printersCache);
    let servers = useSelector(state => state.serversCache);
    
    if (!printerId)
    {
        return(
            <div><h3>Bad printer Id</h3></div>
        );
    }

    let printerName = printers[printerId] ? printers[printerId] : "Printer id = " + printerId;
    let serverName = (serverId && servers[serverId]) ? servers[serverId] : null

return (
        <div>
            <div className = "filter-report-picker">
                <ReportsFilter/>
            </div>
            <BreadcrumbHeader
                location = {location}
                objectLink = {printerName}
                server = {serverName}
                rootPath = {PRINTERS_PATH}
                pathName = "Printer"
            />
            <br/>
                <Tabs defaultActiveKey="1" type="card">
                    <Tabs.TabPane tab={intl.formatMessage({ id: "LeftMenu.Submenu.general" })} key="1">
                        <PrinterReportGeneral printerId = {printerId} filterData = {filterData}/>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={intl.formatMessage({ id: "Detailed" })} key="2">
                    <DetailedReport 
                            api_url = {"/job?printerId=" + printerId} 
                            columns = {getPrinterDetailedColumns()}
                            filterData = {filterData}
                        />
                    </Tabs.TabPane>
                </Tabs>
                <Link to={PRINTERS_PATH}><FormattedMessage id="Back"/></Link>
        </div>);
}

export default PrinterReport;